import { createSelector } from 'reselect';
import { MVT_POE_12 } from '../flags/experiments';
import { INFO_BANNER } from '../flags/features';
import { getCurrentQuery } from './requestSelectors';
import { getOrderPunchCard } from './orderPunchCardsSelectors';
import { whichVariant, isFeatureActive } from './configSelectors';

/* eslint-disable import/prefer-default-export */

export const getOrderStatus = (state) => state.order.status;

export const getMissedCallModal = createSelector(
  [getOrderStatus],
  (orderStatus) => orderStatus && orderStatus.missedCallModal,
);

export const getFulfillmentType = createSelector(
  [getOrderStatus],
  (orderStatus) => orderStatus && orderStatus.fulfillmentType,
);

export const getShouldShowInfoBanner = (state) => {
  const { orderId } = getCurrentQuery(state);
  const punchCardsState = getOrderPunchCard(orderId)(state);
  const isPunchCardVariant = whichVariant(state, MVT_POE_12) === 'punchcard';
  const webInfoBannerFeatureOn = isFeatureActive(state, INFO_BANNER);
  const status = getOrderStatus(state);
  const infoBanner = status.infoBanner;
  const type = infoBanner && infoBanner.type;
  const modalType = infoBanner && infoBanner.modalType;
  const whatsappOptedIn = infoBanner && infoBanner.whatsappOptedIn;

  switch (true) {
    case isPunchCardVariant && punchCardsState.shouldShow:
      return false;
    case !webInfoBannerFeatureOn:
      return false;
    case status.isSharedOrder:
      return false;
    case !infoBanner:
      return false;
    case !type:
      return false;
    case modalType === 'whatsapp' && whatsappOptedIn:
      return false;
    default:
      return true;
  }
};
